// @flow
export const setCookie = (name: string, value: any, maxAge = new Date(Date.now() + 365 * 864e5).toUTCString()) => {
  if (typeof document === 'undefined') return;
  document.cookie = `${name}=${value}; expires=${maxAge}; path=/`;
};



// WEBPACK FOOTER //
// ./src/utils/cookies/index.js